export interface CursorValue {
  key: string;
  value: string | number | boolean | Date;
}
